export const DEFAULT_USER_PICTURE_URL = "/themes/default/images/icons/default-user.png"

export const DEFAULT_USER_PICTURE_URL_ABSOLUTE = () => {
    return window.location.origin  + DEFAULT_USER_PICTURE_URL
}